import graphql__f7a458adda943349d12b from "./__generated__/ContributionFormStepBackMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__f7a458adda943349d12b;

function contributionFormStepBack(contribution, onCompleted) {
  const variables = { contributionId: contribution.id };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { contributionFormStepBack };
